// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --configuration=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular.json`.

export const environment = {
  production: false,
  stripeKey:'pk_test_YtNnt30BLHdbc3GoDsZsrp5S00CoB8DhXx',
  midtrans_url: 'https://api.sandbox.midtrans.com/v2/token', //dev
  midtrans_live: false,
  stripe_client_id:'ca_GHmLSBkdbgc7ycOiTwC7NFLtuI7T5F9q',
  square_url: 'https://sandbox.web.squarecdn.com/v1/square.js', //dev
  transafe_url : 'https://test.transafe.com:443',
  algolia_appId:'plIF9PULAHKJ',
  algolia_api_key:'33382f2e6281756a1ceb6302fbc6bcbe',
     api_url: 'http://client-api-dev2.rentmy.leaperdev.rocks/',
  // api_url: "http://192.168.88.243/rentmy/",
  // api_url: "http://client-api-stage.rentmy.leaperdev.rocks/",
  asset_url: "https://s3.us-east-2.amazonaws.com/pimg.rentmy.co/",
 // api_url: "https://dev1.rentmy.leaperdev.rocks/",
  // api_url:  'http://192.168.88.21/rentmy/' , //arman
  // zahid http://192.168.88.243/rentmy
  //api_url: "https://clientapi.rentmy.co/",
  protocal: "http://",
  storeHoshName: "localhost:4200",
  patnerHoshName: "localhost:4200",
  partner: "localhost",
  port:80,
  path:"dist/rentmy/browser"
};
